import AdSlot from './components/AdSlot';

const JobSideAds = () => {
  return (
    <AdSlot
      slotKey="jobs_side_ad"
      containerClass="jobs_side_ads"
      className="jobs_side_ad_image"
      id="jobs_side_ad"
    />
  );
};

export { JobSideAds };
